<template>
  <div class="mobile-history">
    <Title :title="$root.language.history"></Title>
    <p :class="['weight-bold',font16]">{{$root.language.historyRow1}}</p>
    <p :class="['weight-bold',font16]">{{$root.language.historyRow2}}</p>

    <div class="history-img">
      <img src="@/assets/img/h-1.jpg" width="100%" alt="">
      <div class="img-title font-16 text-center text-white weight-bold">TECHNOLOGY LEADERSHIP</div>
    </div>
    <div class="history-img">
      <img src="@/assets/img/h-2.jpg" width="100%" alt="">
      <div class="img-title font-16 text-center text-white weight-bold">INDUSTRY EXPERIENCE</div>
    </div>
    <div class="history-img">
      <img src="@/assets/img/h-3.jpg" width="100%" alt="">
      <div class="img-title font-16 text-center text-white weight-bold">CUSTOMER VALUE</div>
    </div>
    <p class="font-16 margin-top-50"><span class="font-24 weight-bold">2007</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow3}}</p>
    <p class="font-16"><span class="font-24 weight-bold">2008</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow4}}</p>
    <p class="font-16"><span class="font-24 weight-bold">2014</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow5}}</p>
    <p class="font-16"><span class="font-24 weight-bold">2015</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow6}}</p>
    <p class="font-16"><span class="font-24 weight-bold">2016</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow7}}</p>
    <p class="font-16"><span class="font-24 weight-bold">2019</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow8}}</p>
    <p class="font-16"><span class="font-24 weight-bold">2019</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow9}}</p>
    <div class="font-16"><span class="font-24 weight-bold">2020</span>
      <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow10}}</div>
  </div>
</template>

<script>
import Title from '@/components/title'
export default {
  components: {
    Title
  },
  computed: {
    font16: function () {
      return this.$root.isEnglish ? 'font-16' : 'font-16'
    }
  },
  data () {
    return {
      iconColor: {
        color: '#DA4026'
      }
    }
  }
}

</script>

<style scoped>
.history-img {
  position: relative;
  margin-bottom: 40px;
}

.img-title {
  position: absolute;
  top: 120px;
  width: 100%;
}
</style>
